import { Box, Typography } from "@mui/material";
import React from "react";

interface PropTypes {
	number: number;
}

const EventSessionNumberBadge = ({ number }: PropTypes) => {
	return (
		<Box
			sx={{
				borderRadius: "5px",
				width: 20,
				height: 20,
				minWidth: 20,
				minHeight: 20,
				display: "flex",
				justifyContent: "center",
				backgroundColor: "rgba(123, 97, 255, 1)",
			}}
		>
			<Typography fontWeight="bold" color="white" variant="caption">
				{number}
			</Typography>
		</Box>
	);
};

export default EventSessionNumberBadge;
